import {
    SET_SIGN_UP_FLOW_MODAL,
    SET_SIGN_UP_FLOW_TASKS,
    SignUpFlowActionTypes,
    Task,
    UPDATE_TASK,
    UpdateTaskSchema,
} from './types';

export function SetSignUpFlowTask(payload: Task[]): SignUpFlowActionTypes {
    return {
        type: SET_SIGN_UP_FLOW_TASKS,
        payload,
    };
}
export function UpdateTask(payload: UpdateTaskSchema): SignUpFlowActionTypes {
    return {
        type: UPDATE_TASK,
        payload,
    };
}

export function SetSignUpFlowModal(payload: boolean): SignUpFlowActionTypes {
    return {
        type: SET_SIGN_UP_FLOW_MODAL,
        payload,
    };
}
